// cus_cash_record/index.vue
export const defaultCusCashRecordListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
    sortOrder: 'asc',
}

// customer/index.vue
export const defaultCustomerListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}
export const defaultCustomer = {
    email: null,
    icon: null,
    id: null,
    name: null,
    password: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
    username: null
}

// display/components/DisplayHistory.vue
export const defaultDisplayHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    code: null,
    state: null,
}

// display/index.vue
export const defaultDisplayListQuery = {
    pageNum: 1,
    pageSize: 15,
    code: null,
    state: null,
}
export const defaultSmsDisplay = {
    id: null,
    name: "",
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    note: null,
    code: null,
    place: null,
    type: null,
    employeeId: null,
    employeeName: ""
}

// item_transaction/index.vue
export const defaultItemTransactionListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
    reference: null,
    sku: null,
    categoryName: null,
    inItnx: null,
    outItnx: null
}

// item_transaction/item_transaction_history.vue
export const defaultItemTransactionHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// order_form/components/order_form_details.vue
export const defaultOrderFormRawWt = {
    totalK: null,
    totalP: null,
    totalY: null,
    totalG: null,
}

export const defaultTransaction = {
    id: null,
    itnxNo: null,
    place: null,
    customerId: null,
    reference: null,
    subReferences: null,
    customerName: "",
    io: 1,
    tnxFor: 0,
    of: 1,
    sku: null,
    description: null,
    note: "",
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    quality: "",
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 3,
    wtStr: "",
    employeeId: null,
    employeeName: ""
}

export const defaultOrder = {
    id: null,
    orderFormNo: null,
    place: null,
    appointment: null,
    customerId: null,
    customerName: null,
    count: 0,
    note: null,
    rateType: 2,
    orderStatus: 0,
    usdRate: null,
    goldRate: null,
    rateNote: null,
    islh: 0,
    employeeId: null,
    employeeName: null,
    orderItems: [],
    itemTransactions: [],
    cashTransactions:[],
    ofAudits: [],
}

export const defaultOrderItem = {
    id: null,
    pic: null,
    imageFile: null,
    orderFormNo: null,
    orderItemNo: null,
    ofType: 1,
    appointment: null,
    place: null,
    customerId: null,
    customerName: null,
    qty: 1,
    qtyUnit: 1,
    categoryId: null,
    parentCategoryId: null,
    categoryName: null,
    quality: null,
    design: null,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    rateNote: null,
    employeeId: null,
    employeeName: null,
    voucherId: null,
    voucherNo: null,
}

// order_form/index.vue
export const defaultOrderListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// order_form/order_items.vue
export const defaultOrderItemsListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// pandy/components/PandyDetails.vue
export const defaultPandy = {
    id: null,
    pandyNo: null,
    pandyType: 1,
    place: null,
    customerSmithId: null,
    customerSmithName: null,
    count: 1,
    note: null,
    isAllReturned: 0,
    returnedCount: 0,
    returnedNote: null,
    returnedAt: null,
    returnedPlace: null,
    returnedCustomerSmithId: null,
    returnedCustomerSmithName: null,
    receivedEmployeeId: null,
    receivedEmployeeName: null,
    sort: 100,
    crudStatus: 2,
    createdAt: null,
    lastUpdate: null,
    employeeId: null,
    employeeName: null,
    pandyItems: []
}

// pandy/components/PandyTable.vue
export const defaultPandyTableListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// pandy/index.vue
export const defaultPandyListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// quote/components/QuotationDetail.vue
export const defaultQuotationParam = {
    id: 0,
    customerId: null,
    customerName: null,
    note: null,
    createdAt: null,
    lastUpdate: null,
    qty: 0,
    prUsd: 0,
    prKpy: 0,
    prGram: 0,
    prExtra: null,
    prCalculated: null,
    prDollarCalculated: null,
    duration: 0,
    expiredDate: null,
    quoteList: [],
}

export const defaultQuotationDetailQuote = {
    id: null,
    categoryId: null,
    parentCategoryId: null,
    productId: null,
    lotNo: null,
    categoryName: null,
    of: 2,
    name: null,
    pic: null,
    note: null,
    qty: null,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 3,
    wtTotal: null,
    wtLoss: null,
    wtGem: null,
    wtNet: null,
    prSemi: null,
    prLabor: null,
    prPt2c: null,
    prMarkup: null,
    prPercent: null,
    prCalculated: null,
    prDollarCalculated: null,
    prGold: null,
    prSemiAmount: null,
    prCurrency: 2,
    duration: 0,
    expiredDate: null,
    componentList: [],
    rtUsd: null,
    rtKpy: null,
    rtGrm: null,
    imageFile: null,
    quoteType: 1,
}

// quote/index.vue
export const defaultQuoteListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
    quotationCode: null,
    customerName: null,
}

// quote/quote_items.vue
export const defaultQuoteItemsListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

export const defaultQuote = {
    id: null,
    categoryId: null,
    parentCategoryId: null,
    productId: null,
    lotNo: null,
    categoryName: null,
    of: 2,
    name: null,
    pic: null,
    note: null,
    qty: null,
    qtyUnit: 1,
    wt: null,
    wtUnit: 3,
    wtTotal: null,
    wtLoss: null,
    wtGem: null,
    wtNet: null,
    prSemi: null,
    prLabor: null,
    prPt2c: null,
    prMarkup: null,
    prPercent: null,
    prCalculated: null,
    prGold: null,
    prSemiAmount: null,
    prCurrency: 2,
    duration: 0,
    expiredDate: null,
    componentList: [],
    rtUsd: null,
    rtKpy: null,
    rtGrm: null
}

// return_in/components/ReturnInDetails.vue
// return_in/components/ReturnInItemForm.vue
// voucher/components/VoucherDetails.vue
// voucher/components/VoucherItemForm.vue
// voucher/voucher_items.vue (shared — identical shape)
export const defaultRawWt = {
    totalK: null,
    totalP: null,
    totalY: null,
    totalG: null,
    lossK: null,
    lossP: null,
    lossY: null,
    lossG: null,
    lossPc: null,
    gemK: null,
    gemP: null,
    gemY: null,
    gemG: null,
    netK: null,
    netP: null,
    netY: null,
    netG: null,
    cusK: null,
    cusP: null,
    cusY: null,
}

export const defaultReturnIn = {
    id: null,
    riNo: null,
    place: null,
    customerId: null,
    customerName: null,
    count: 0,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    gramRate: null,
    rateNote: null,
    totalAmount: null,
    roundingMarkup: 0,
    returnInPercent: 0,
    reduction: 0,
    taxMarkup: 0,
    taxPercent: 0,
    tax: null,
    netAmount: null,
    paidAmount: null,
    balance: null,
    status: 0,
    employeeId: null,
    employeeName: null,
    returnInItems: [],
}

export const defaultReturnInItem = {
    id: null,
    productId: null,
    riNo: null,
    riItemNo: null,
    of: 1,
    place: null,
    customerId: null,
    customerName: null,
    inventoryType: 1,
    refNo: null,
    sku: null,
    pic: null,
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 1,
    wtStr: null,
    wtLoss: null,
    wtGem: null,
    wtNet: null,
    categoryId: null,
    parentCategoryId: null,
    categoryName: null,
    quality: null,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    gramRate: null,
    rateNote: null,
    prSemi: 0.00,
    prLabor: 0.00,
    prPt2c: 0.00,
    prMarkup: 0.00,
    prPercent: 0.00,
    prSemiAmount: 0.00,
    prCurrency: 0,
    prFormula: 0,
    misc: 0,
    totalAmount: 0,
    roundingMarkup: 0,
    returnInPercent: 0,
    reduction: 0,
    taxMarkup: 0,
    taxPercent: 0,
    tax: 0,
    netAmount: null,
    employeeId: null,
    employeeName: null,
    componentList: [],
    displayId: null,
    displayName: null,
    state: null,
}

// return_in/index.vue
export const defaultReturnInListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// return_in/return_in_history.vue
export const defaultReturnInHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// return_in/return_in_items.vue
export const defaultReturnInItemsListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// slot/components/SlotHistory.vue
export const defaultSlotHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    code: null,
    status: null,
}

// slot/index.vue
export const defaultSlotListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
    displayCode: null,
    state: null,
}
export const defaultSmsSlot = {
    id: null,
    code: null,
    displayId: null,
    displayCode: null,
    employeeId: null,
    employeeName: ""
}

// track_record/index.vue
export const defaultTrackRecordListQuery = {
    pageNum: 1,
    pageSize: 15,
    slotCode: null,
    state: 1, // smsTrackRecordState.Active
}
export const defaultSmsTrackRecord = {
    id: null,
    slotId: null,
    displayId: null,
    code: null,
    productId: null,
    slotCode: null,
    of: null,
    sku: null,
    categoryName: null,
    name: null,
    recordNote: null,
    inDate: null,
    outDate: null,
    place: null,
    inItnx: null,
    outItnx: null,
    branchCode: null,
    employeeId: null,
    employeeName: "",
}

// transfer/components/TransferDetails.vue
export const defaultTransfer = {
    id: null,
    transferNo: null,
    place: null,
    ownerEmployeeId: null,
    ownerEmployeeName: null,
    count: 1,
    note: null,
    isAllReceived: 0,
    receivedCount: 0,
    receivedNote: null,
    receivedAt: null,
    receivedPlace: null,
    receivedBranchName: null,
    receivedEmployeeId: null,
    receivedEmployeeName: null,
    sort: 100,
    crudStatus: 2,
    createdAt: null,
    lastUpdate: null,
    employeeId: null,
    employeeName: null,
    transferItems: []
}

// transfer/components/TransferTable.vue
export const defaultTransferTableListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// transfer/index.vue
export const defaultTransferListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// vendor/index.vue
export const defaultVendorListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}
export const defaultVendor = {
    email: null,
    icon: null,
    id: null,
    name: null,
    password: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
    username: null
}

// voucher/components/VoucherDetails.vue
export const defaultVoucher = {
    id: null,
    voucherNo: null,
    place: null,
    customerId: null,
    customerName: null,
    count: 0,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    gramRate: null,
    rateNote: null,
    totalAmount: null,
    discountMarkup: 0,
    discountPercent: 0,
    discount: 0,
    taxMarkup: 0,
    taxPercent: 0,
    tax: null,
    netAmount: null,
    netDollarAmount: null,
    paidAmount: null,
    balance: null,
    dollarBalance: null,
    status: 0,
    referenceType: null,
    referenceId: null,
    referenceNo: null,
    employeeId: null,
    employeeName: null,
    isGift: null,
    voucherItems: [],
}

export const defaultVoucherItem = {
    id: null,
    productId: null,
    voucherNo: null,
    voucherItemNo: null,
    sku: null,
    of: null,
    place: null,
    customerId: null,
    customerName: null,
    inventoryType: 1,
    refNo: null,
    pic: null,
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 1,
    wtStr: null,
    wtLoss: null,
    wtGem: null,
    wtNet: null,
    cusWtStr: null,
    categoryId: null,
    parentCategoryId: null,
    categoryName: null,
    quality: null,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    gramRate: null,
    rateNote: null,
    prSemi: 0.00,
    prGold: 0.00,
    prLabor: 0.00,
    prPt2c: 0.00,
    prMarkup: 0.00,
    prPercent: 0.00,
    prSemiAmount: 0.00,
    prCurrency: 2,
    prFormula: 0,
    misc: 0,
    totalAmount: 0,
    cusGoldPrice: null,
    totalDollarAmount: 0,
    discountMarkup: 0,
    discountPercent: 0,
    discount: 0,
    taxMarkup: 0,
    taxPercent: 0,
    tax: 0,
    netAmount: null,
    netDollarAmount: null,
    employeeId: null,
    employeeName: null,
    componentList: []
}

// voucher/components/VoucherItemComponentDetails.vue
export const defaultComponent = {
    id: null,
    note: null,
    of: 1,
    crudStatus: null,
    prAmount: null,
    prCurrency: 2,
    prFormula: 1,
    prMarkup: null,
    prPercent: null,
    prCalculated: null,
    prUnit: 1,
    prPrice: null,
    attributeCategoryId: null,
    parentCategoryId: 0,
    categoryId: 0,
    categoryName: null,
    productId: 0,
    productLotNo: null,
    qty: null,
    qtyUnit: 1,
    quality: null,
    wt: null,
    wtUnit: 1,
    selectedAttributes: [],
    selectedParameters: []
}

// voucher/index.vue
export const defaultVoucherListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// voucher/voucher_items.vue
export const defaultVoucherItemsListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}
